
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MicrosoftTenantModel extends Model<MicrosoftTenantModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'guid', languageString: 'microsoftTenant.property.companyId' },
		{ name: 'tenantId', type: 'number', languageString: 'microsoftTenant.property.tenantId' },
		{ name: 'msCustomerTenantId', type: 'guid', languageString: 'microsoftTenant.property.msCustomerTenantId' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public tenantId: number;
	public msCustomerTenantId?: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.tenantId = 0;
		this.msCustomerTenantId = undefined;
		
	}
	getProperties(){
		return MicrosoftTenantModel.classProperties;
	}
}

